import React from "react";
import {
  Table,
} from "reactstrap";
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";

const STATUS_BADGES = {
  show: { label: 'Show', color: '#0ca30c' },
  pending: { label: 'Pendente', color: '#b8621f' },
  noShow: { label: 'No Show', color: '#d03b3b' },
};

export default function GuestsList({
  guestsList = [],
  groups = [],
  loading = false,
  getGuestHistory,
}) {
  return (
    <div style={{ paddingBottom: '10px' }}>
      <div className="table-responsive">
        <Table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th>Nome</th>
              <th>E-mail</th>
              <th>Grupo</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <LoadingSkelentonTable lines={10} cols={5} />
            ) : (
              guestsList.map((guest) => renderRow(guest))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )

  function renderRow(guest = {}) {
    const _group = groups.find((g) => `${g.id}` === `${guest.grupoId}`);
    return (
      <tr key={guest.id}>
        <td>{guest.nome}</td>
        <td>{guest.email}</td>
        <td>{_group?.text || '-'}</td>
        <td>{renderStatusBadge(guest.status)}</td>
        <td>
          <i
            className="mdi mdi-eye"
            title="Ver histórico de check-ins"
            style={{ color: "blue", fontSize: 17, cursor: "pointer" }}
            onClick={() => getGuestHistory(guest)}
          />
        </td>
      </tr>
    )
  }

  function renderStatusBadge(status = 'pending') {
    const _badge = STATUS_BADGES[status] || STATUS_BADGES.pending;
    return (
      <span
        style={{
          backgroundColor: _badge.color,
          color: 'white',
          padding: '2px 8px',
          borderRadius: 4,
          fontSize: 12,
          fontWeight: 'bold',
        }}
      >
        {_badge.label}
      </span>
    );
  }
}
